<template>
  <main>
    <mdb-container>
      <mdb-row>
        <mdb-col col="12" class="text-center mt-3">
          <h1 class="font-weight-bold pentagon-red">Actief</h1>
        </mdb-col>

        <mdb-col
          md="3"
          v-for="year in active.years"
          :key="year.year"
        >
          <Jaar
            :year="year"
          />
        </mdb-col>
      </mdb-row>

      <mdb-row>
        <mdb-col col="12" class="text-center mt-3">
          <h1 class="font-weight-bold pentagon-green">Reünisten</h1>
        </mdb-col>

        <mdb-col
          md="3"
          v-for="year in inactive.years"
          :key="year.year"
        >
          <Jaar
            :year="year"
          />
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </main>
</template>

<script>
  import { mdbRow, mdbCol, mdbContainer } from 'mdbvue';
  import Jaar from '../components/Jaar';

  export default {
    name: 'Leden',
    components: {
      mdbRow,
      mdbCol,
      mdbContainer,
      Jaar
    },
    data() {
      return {
        active: {
          years: [
            {
              year: 2023,
              members: [
                'Daniel Jonkman',
                'Thor van Lent',
                'Sebastiaan Hartings',
                'Lars Elling',
                'Tom Peters',
              ]
            },
            {
              year: 2022,
              members: [
                'Bas Geiger',
                'Kees Groenen',
                'Niek Broer',
                'Rijk Hendriks',
              ]
            },
            {
              year: 2021,
              members: [
                'Tommie Schotema',
                'Tim Pouw',
                'Jelle Immerzeel',
                'Fabrice Verhoeff',
                'Kian Kashanian',
                'Moos Barnhoorn',
                'Jelle Zeilstra',
                'Niels Stunnenberg',
              ]
            },
            {
              year: 2020,
              members: [
                'Stijn van den Erf',
                'Hugo Dekker',
                'Lode Schouten',
                'Ward Edelaar',
                'Pieter Klarich'
              ]
            },
            {
              year: 2019,
              members: [
                'Joachim van der Lei',
                'Daniel Genet',
                'Jan Balkenende',
              ]
            }
          ]
        },
        inactive: {
          years: [
            {
              year: 2018,
              members: [
                'Quincy van Stenus',
                'Ties Adrichem',
                'Wes Wijte'
              ]
            },
            {
              year: 2017,
              members: [
                'Stan Wentholt',
                'Mazeyar Rezaei Ghavamabadi',
                'Ruben Farid Mojtahedi'
              ]
            },
            {
              year: 2016,
              members: [
                'Milan Smit',
                'Coen van Dasler',
                'Jesper van de Sanden'
              ]
            },
            {
              year: 2015,
              members: [
                'Jan Langedijk',
                'Roy van Leeuwen',
                'Ruben Strijbosch',
                'Jelmer Strijbosch',
                'Bastiaan Engelenburg',
                'Matthijs Kollaard',
                'Sebas Vissers',
                'Olaf Groen'
              ]
            },
            {
              year: 2014,
              members: [
                'Thuur Wilde',
                'Stan Thijsen',
                'Ralf Meijer',
                'Loek van Amerongen',
                'Koen Smetsers'
              ]
            },
            {
              year: 2013,
              members: [
                'Tom Siebeler',
              ]
            },
            {
              year: 2012,
              members: [
                'Dylan Wijman',
                'Maarten Stokhof',
                'Gerben Vermeulen',
                'Bart van Oorschot',
                'Levi Bakker',
                'Thomas Verweijen',
                'Bas de Witte',
              ]
            },
            {
              year: 2011,
              members: [
                'Roland Felt',
                'Daniël Verstift',
                'Danny Visser',
              ]
            },
            {
              year: 2010,
              members: [
                'Raymond van Venetië',
                'Floris de Voogd',
                'Rick de Graaf',
                'Tom Swinkels',
              ]
            },
            {
              year: 2009,
              members: [
                'Remon Miltenburg',
                'Thomas Krupers',
                'Jasper M. Jager ✞',
              ]
            },
            {
              year: 2008,
              members: [
                'Adnan Ramlawi',
                'Bas Koning',
                'Peeters',
              ]
            },
            {
              year: 2007,
              members: [
                'Eduard Vaneker',
                'Niki Ceulemans',
              ]
            },
            {
              year: 2006,
              members: [
                'Kees van den Bos',
                'Gijs Leppink',
                'Michiel van Werkhoven',
                'Dennis Gijsbers',
                'Arthur Meijer',
                'Merwijn Zweers',
              ]
            },
            {
              year: 2005,
              members: [
                'Justin Piersma',
              ]
            },
            {
              year: 2004,
              members: [
                'Peter van Ulden',
                'Rutger van den Berg',
                'Niels Bassie',
                'Jan Kunst',
                'Niels Beeftink',
                'Niels Bark',
              ]
            },
            {
              year: 2003,
              members: [
                'Michiel Roodenburg',
                'Thijs van de Laar',
                'Tom Peeters',
                'Floris van Altena',
              ]
            },
            {
              year: 2002,
              members: [
                'Daan Zwarter',
                'Peter Paul Verhoef',
                'Chris Kolder',
                'Quinten Koekenbier',
                'Eric Klaassen',
                'Sven van Groeningen',
              ]
            },
            {
              year: 2001,
              members: [
                'Paul Perizonius',
                'Laurens Koelewijn',
              ]
            },
            {
              year: 2000,
              members: [
                'Frank Wijlens',
                'Ivo Vis',
                'Frank de Kleyn',
                'Jeroen Hannink',
                'Peter Geurts',
                'Marijn Faassen',
              ]
            },
            {
              year: 1998,
              members: [
                'Jeroen Derkx',
              ]
            },
            {
              year: 1997,
              members: [
                'Jaap Propitius',
                'Stefan Rakhorst',
                'Leo Santing',
                'Matthijs Weevers',
              ]
            },
            {
              year: 1996,
              members: [
                'Wouter Stevens',
                'Radek Ruhlmann',
                'Bastiaan Rademakers',
                'Tom Foolen',
                'Sjors Buwalda',
                'Jeroen van den Brink',
              ]
            },
            {
              year: 1995,
              members: [
                'Emile van Dijk',
                'Arthur Kuiters',
              ]
            },
            {
              year: 1994,
              members: [
                'Marc Aafjes',
                'Andre Lockhorst',
                'Willem du Pon',
                'Boudewijn Weijers',
              ]
            },
            {
              year: 1993,
              members: [
                'David Simons',
                'Arjan Roosen',
                'Kees van den Berg',
              ]
            },
            {
              year: 1992,
              members: [
                'Jeff Visser',
                'Remko van de Peppel',
                'Lyndon Oosterwolde',
              ]
            },
            {
              year: 1991,
              members: [
                'Dennis Veldhuizen',
                'David van Koningsveld',
              ]
            },
            {
              year: 1990,
              members: [
                'Dave van Voorst',
                'Stijn Thiecke',
                'Hein Schumacher',
                'Daniël van der Leij',
                'Martijn van Laer',
              ]
            },
            {
              year: 1989,
              members: [
                'Maarten Edixhoven',
                'Ruben Dekker',
                'Christiaan Boelen',
              ]
            },
            {
              year: 1988,
              members: [
                'Bas Wolffenbuttel',
                'Wouter Winkel',
                'Krijn Taconis',
                'Nathal van Rijn',
                'Hans Reinigert',
                'Jeroen Brauns',
                'Rob van der Eijden',
                'Sander Boelen',
                'Klaas van Gelder',
              ]
            },
          ]
        }
      }
    },
    created() {
      this.$store.commit('TOGGLE_OFF_NAVBAR_TRANSPARENT');
    }
  };
</script>

<style scoped>

</style>
